var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86188 4.61758L1.33891 3.33593C0.637803 1.6177 2.45162 -0.0460068 4.10305 0.800552L10.1363 3.89334C11.5904 4.63872 11.5855 6.71869 10.1279 7.45719L3.81265 10.6569C2.16385 11.4923 0.361294 9.83571 1.05485 8.12241L1.86397 6.12364C2.05954 5.64053 2.05879 5.10015 1.86188 4.61758Z",
    fill: "#60F0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVector);
export default __webpack_public_path__ + "static/media/blue-vector.939e9cee667072eadec5d79a4d18aada.svg";
export { ForwardRef as ReactComponent };